<template>
	<div class="interest">
		<div class="container">
			<v-touch class="interest_more" @tap="toMore()"></v-touch>
			<div class="interest_tips"></div>
			<v-touch class="interest_content" @tap="recomendList()" :style="{background:initColor.bg}">
				<div class="content">
					<div class="content_data">- {{initTime}} -</div>
					<div class="content_week">{{initWeek}}</div>
					<div class="content_title">
						<p>
							<span class="content_title_name">{{funTest.name}}</span>
							<span class="content_title_bg" :style="{background:initColor.text_bg}"></span>
						</p>
						
					</div>
				</div>
				<img :src="funTest.introPicture" alt="" class="interest_bg">
				<div class="interest_bg2" :style="{background:initColor.graph_bg}"></div>
				<img src="../../../assets/ceshi/index-bg.png" class="interest_bg3" alt="">
			</v-touch>
		</div>
	</div>
</template>

<script>
	export default {
			name: 'interest',
			components: {

			},
			data() {
				return {

				}
			},
			watch:{
			},
			props: ['funTest'],
			computed: {
				initTime(){
					return this.timeTransform(new Date(),'day')
				},
				initWeek(){
					const weekS = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"),
					 	  str = weekS[new Date().getDay()];
					return str  
				},
				initColor(){
					return this.getColorType(parseInt(new Date().getDay()))
				}
			},
			mounted() {
			},
			methods: {
				recomendList(){
					const that = this;
					that.$emit('testClick',this.funTest)
				},
				toMore(){
					this.$emit('moreFunTest','每日一测')
				}
			}
	}
</script>

<style lang="scss">
@import '../../../scss/function';
.interest{
    position: relative;
    overflow: hidden;
    .container{
    	 margin: topx(30rem) topx(0) topx(10rem) topx(40rem);
    }
	.interest_title{
        margin-bottom: topx(10rem);
        &.hot {
            width: topx(206rem);
            height: topx(37rem);
            background: url('../../../assets/show/indexTitle/indexTitle_hot.png') no-repeat;
            background-size: cover;
        }
        &.new {
            width: topx(212rem);
            height: topx(37rem);
            background: url('../../../assets/show/indexTitle/indexTitle_new.png') no-repeat;
            background-size: cover;
        }
	}
	.interest_tis{
	    margin-bottom: topx(30rem);
	    color: #999999;
	    line-height: 1.1;
	}
	.interest_more{
		width: topx(118rem);
		height: topx(58rem);
		position:absolute;
		right: topx(40rem);
		bottom: topx(10rem);
		background: url('../../../assets/ceshi/icon-more.png') no-repeat;
		background-size: 100% 100%;
		z-index: 4;
	}
	.interest_tips{
		width: topx(142rem);
		height: topx(68rem);
		position:absolute;
		left: topx(40rem);
		top: topx(30rem);
		background: url('../../../assets/ceshi/dayceshi.png') no-repeat;
		background-size: 100% 100%;
		z-index: 4;
	}
	.interest_content{
		width: topx(670rem);
		height: topx(220rem);
		border-radius: topx(10rem);
		position: relative;
		overflow: hidden;
		background: #5B5887;
		.content{
			z-index: 3;
			position: absolute;
			width: 100%;
			height: 100%;
		}
		.content_data{
			font-size: topx(22rem);
			color: #FFFFFF;
			line-height: topx(22rem);
			text-align:center;
			margin-top: topx(50rem);
		}
		.content_week{
			font-size: topx(38rem);
			color: #FFFFFF;
			line-height: topx(38rem);
			text-align:center;
			margin-top: topx(10rem);
		}
		.content_title{
			font-size: topx(38rem);
			color: #FFFFFF;
			line-height: topx(38rem);
			text-align:center;
			margin-top: topx(17rem);
			font-weight: bold;
			p{
                display: inline-block;
                position: relative;
			}
			.content_title_bg{
                content: '';
                width: 100%;
                height: topx(26rem);
                position: absolute;
                bottom: topx(-10rem);
                content: '';
                left: 0;
                z-index: -1;
			}
			.content_title_name{
				height: topx(40rem);
				overflow: hidden;
				display: inline-block;
				
			}

		}
	}
	.interest_bg{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 0;
		filter: blur(2px);
		opacity: 0.4;
	}
	.interest_bg2{
		width: topx(270rem);
		height: topx(270rem);
		border-radius: 100%;
		position: absolute;
		top: topx(14rem);
		left: 50%;
		margin-left: topx(-135rem);
		opacity: 0.8;
		background: #69D1C2;
		z-index: 2;
	}
	.interest_bg3{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 1;

	}
}
</style>



// WEBPACK FOOTER //
// src/components/show/index/interestSwiper.vue